import { render, staticRenderFns } from "./applicants-information.vue?vue&type=template&id=188343e5&scoped=true"
import script from "./applicants-information.vue?vue&type=script&lang=ts"
export * from "./applicants-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188343e5",
  null
  
)

export default component.exports